export default `<?xml version="1.0" encoding="UTF-8"?>
<svg width="96px" height="96px" viewBox="0 0 96 96" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <title>Icon/Question/Red96</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon/Question/Red96">
            <g id="Group" transform="translate(39.750000, 30.750000)">
                <path class="path" d="M7.43292882,27.75 L7.43292882,22.9296826 C7.43292882,19.8274093 9.2399564,16.9006131 12.129714,15.4306856 C15.1045372,13.8815894 16.8529273,10.6168976 16.4399868,7.26895625 C16.0270463,3.51374455 12.962202,0.484926772 9.16232359,0.0768403025 C8.91373342,-0.0064093374 8.58751043,0.00012004612 8.2588098,0.00012004612 C6.19410735,0.00012004612 4.30366579,0.733043346 2.73614369,2.0405524 C1.00014187,3.58964864 0,5.87574904 0,8.16184944" id="Page-1" stroke="#F91661" stroke-width="1.5"></path>
                <rect class="dot" id="Rectangle-2" fill="#F91661" x="6" y="31.5" width="3" height="3" rx="0.75"></rect>
            </g>
            <circle class="circle" id="Oval-5" stroke="#F91661" stroke-width="1.5" cx="48" cy="48" r="47"></circle>
        </g>
    </g>
</svg>`;
